import React, { useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import PageHeader from '../../../sharedModules/layout/PageHeader';
import { SnackBarContext } from '../../../sharedModules/form/contexts/SnackBarContext';
import { useGet } from '../../../sharedModules/hooks/useQuery';
import InspectionReportFormPage from '../../inspectionReport/pages/InspectionReportFormPage';
import type { InspectionFormValues } from '../../inspectionReport/pages/InspectionReportFormPage';

interface InspectionJobData {
  customer_name?: string;
  scheduled_date?: string;
  emp_id?: string | null;
  emp_id_secondary?: string | null;
  order_no?: string;
}

const headerProps = {
  mainTitle: 'Home Inspections',
  subTitle: 'Fill Inspection Report',
  backButtonLabel: "Back to Today's Inspections",
  backButtonLink: '/home_services/upcoming_inspections',
};

const UpcomingJobFillPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { showSuccessSnackBar } = useContext(SnackBarContext);

  const {
    data: jobResponse,
    isLoading,
    error,
  } = useGet<InspectionJobData>({
    url: `/home_services/inspection_jobs/${id}`,
    enabled: !!id,
  });

  const jobData = jobResponse?.data;
  const errorMessage = error
    ? (error as any)?.response?.data?.error || (error as any)?.response?.data?.message || 'Failed to load job'
    : '';

  const prefillData: Partial<InspectionFormValues> | null = jobData
    ? {
        customerName: jobData.customer_name || '',
        date: jobData.scheduled_date || '',
        technician: [jobData.emp_id, jobData.emp_id_secondary].filter(Boolean).join(', '),
        workOrderNumber: jobData.order_no || '',
      }
    : null;

  const handleSubmitSuccess = () => {
    showSuccessSnackBar?.('Inspection report submitted successfully!');
    history.push('/home_services/upcoming_inspections');
  };

  if (isLoading) {
    return <LoadingWrapper isLoading />;
  }

  if (errorMessage) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
        <PageHeader {...headerProps} />
        <Typography color="error" sx={{ mt: 2 }}>
          {errorMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ px: 3, pt: 3, maxWidth: 1200, margin: '0 auto' }}>
        <PageHeader {...headerProps} />
      </Box>
      {prefillData && (
        <InspectionReportFormPage
          homeInspectionJobId={id}
          prefillData={prefillData}
          headerDisabled
          title="Inspection Report"
          onSubmitSuccess={handleSubmitSuccess}
        />
      )}
    </>
  );
};

export default UpcomingJobFillPage;
